import React, { useCallback, useMemo } from "preact/compat";
import { useEffect, useState } from "react";
import SlideshowSlick from "../../../SlideshowSlick";
// import { preloadImage } from "../../../utils/misc";
import { getItem, setItem } from "../../../utils/storage";

const EstateSlideshow = ({ area, addEvent, idStorage, isHidden, company }) => {
  const framesCount = useMemo(() => ((area.data?.length ?? 1) - 1), [area]);
  const initialFrame = useMemo(() => ((getItem(idStorage) ?? 0) > framesCount ? 0 : getItem(idStorage) || 0), [framesCount]);
  const [currentFrame, setCurrentFrame] = useState(initialFrame);
  const [currentEstate, setCurrentEstate] = useState(area.data[initialFrame]);

  useEffect(() => {
    if (isHidden && currentFrame !== initialFrame) {
      setCurrentFrame(initialFrame);
      setCurrentEstate(area.data[initialFrame]);
    }
  }, [isHidden]);

  useEffect(() => {
    setCurrentFrame(initialFrame > framesCount || initialFrame < 0 ? 0 : initialFrame);
    setCurrentEstate(area.data[initialFrame > framesCount || initialFrame < 0 ? 0 : initialFrame]);
  }, [idStorage]);

  useEffect(() => {
    // const nextFrame = currentFrame + 1:
    // const imgToLoad = area.data[nextFrame > framesCount || nextFrame < 0 ? 0 : nextFrame]?.frameContent?.preloadPictures;

    // if (imgToLoad?.length) {
    //   imgToLoad.map((src) => {
    //     preloadImage(src).then(() => { });
    //   });
    // }

    if (!isHidden) {
      setItem(idStorage, (parseInt(currentFrame) + 1) <= framesCount ? parseInt(currentFrame) + 1 : 0);
    }
  }, [currentFrame]);

  const overlayFrame = useCallback((estate) => {
    if (!estate?.medias) {
      return null;
    }

    const html = estate?.frameContent?.html;

    return (
      <div className={`overlay_frame ${isHidden ? 'has-animations' : ''}`} dangerouslySetInnerHTML={{ __html: html }} />
    )
  }, [isHidden]);

  const appendFrame = useCallback((estate) => {
    const html = estate?.frameContent?.html;

    return (<div style={{ height: '100%', width: '100%', position: 'absolute', zIndex: 10 }} className={`append_frame ${isHidden ? 'has-animations' : ''}`} dangerouslySetInnerHTML={{ __html: html }} />);
  }, [isHidden]);

  const updateCurrentFrame = useCallback(() => {
    if (!isHidden) {
      const nextFrame = currentFrame + 1;
      const shouldContinue = addEvent('updateFrame', area.slug, nextFrame);

      if (shouldContinue) {
        setCurrentEstate(area.data[framesCount >= nextFrame ? nextFrame : 0]);
        setCurrentFrame(framesCount >= nextFrame ? nextFrame : 0);
      } else {
        addEvent('end', area.slug, nextFrame);
      }
    }
  }, [currentFrame, framesCount, area, isHidden, addEvent]);

  const slides = currentEstate?.medias?.length ? currentEstate?.medias.filter((media) => !window?.blacklist?.includes(media.url)) : [currentEstate?.frameContent?.html];

  const initialDelay = area?.widget?.config?.slide_time ?? 25;
  const delay = initialDelay * 1000;

  const type = (currentEstate?.medias?.length ? 'slide' : 'html');

  if ((currentEstate?.frameContent?.preloadPictures ?? []).filter((picture) => window?.blacklist?.includes(picture)).length > 0) {
    updateCurrentFrame();

    return null;
  }

  if (!slides) {
    return null;
  }

  return (
    <>
      {type !== 'html' ? appendFrame(currentEstate) : null}
      <SlideshowSlick
        key={area.id}
        isUniq={area?.data?.length === 1}
        logo={company?.logo}
        areaId={`${area.id}_${currentFrame}`}
        infinite={area?.data?.length === 1}
        isFirst={currentFrame === initialFrame}
        isHidden={isHidden}
        lazyLoad='progressive'
        fade={true}
        // slides={currentEstate?.medias || [currentEstate.frameContent.html]}
        slides={slides}
        // mode={currentEstate?.medias ? 'slide': 'html'}
        mode={type}
        onEnd={(name, data) => { !isHidden ? updateCurrentFrame() : null }}
        onEvent={(eventType, data) => {
          addEvent(eventType, area.slug, data);
        }}
        overlayFrame={() => overlayFrame(currentEstate)}
        // appendFrame={() => appendFrame(currentEstate)}
        delay={delay}
      />
    </>
  )
}

EstateSlideshow.defaultProps = {
  addEvent: () => { }
}

export default React.memo(EstateSlideshow, (props, nextProps) => {
  return props.area?.id === nextProps.area?.id && props.isHidden === nextProps.isHidden && props.area?.uniqId === nextProps.area?.uniqId;
})
